'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const coreActions = /*#__PURE__*/ react.css({
    padding: "8px 0",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-CoreActions-web-stylescoreActions", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2JlbmFpYWhiYXJhbmdvL2Rldi9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9Qcm9kdWN0Q2FyZC9Db3JlQWN0aW9ucy9Db3JlQWN0aW9ucy53ZWIuc3R5bGVzLnRzIiwic291cmNlcyI6WyIvVXNlcnMvYmVuYWlhaGJhcmFuZ28vZGV2L2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1Byb2R1Y3RDYXJkL0NvcmVBY3Rpb25zL0NvcmVBY3Rpb25zLndlYi5zdHlsZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5cbmltcG9ydCB7IHpJbmRleCB9IGZyb20gXCIjY29uc3RhbnRzXCI7XG5cbmV4cG9ydCBjb25zdCBjb3JlQWN0aW9ucyA9IGNzcyh7XG4gIHBhZGRpbmc6IFwiOHB4IDBcIixcbiAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgekluZGV4OiB6SW5kZXguY2FyZEFjdGlvbixcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkyQiJ9 */");

exports.coreActions = coreActions;
//# sourceMappingURL=CoreActions.web.styles.cjs.map
